<div class="modal-wrapper">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title" i18n="@@general.tsa.delete">
      Delete TSA
    </h4>
    <i class="fas fa-times" (click)="onClose()"></i>
  </div>
  <div class="modal-body">
    <div>
      <p>
        <strong i18n="@@document.list.signed.delete.description">
          Be aware that the signed TSA document will be lost when you continue
          the operation.
        </strong>
      </p>
    </div>
    <div class="card remarks-container">
      <div class="card-title" i18n="@@document.list.signed.delete.reason">
        Reason for delete
      </div>
      <textarea
        placeholder="Add reason for delete"
        maxlength="300"
        [(ngModel)]="remarks"
      ></textarea>
    </div>
  </div>
  <div class="modal-footer">
    <span
      class="cancelBtn clickable"
      (click)="onClose()"
      i18n="@@general.cancel"
      >Cancel</span
    >

    <button [disabled]="!canSave" class="save-button" (click)="onSave()">
      <img src="assets/Keen&Wise_save_transparant.png" />
    </button>
  </div>
</div>
